export const uk = {
    'agency:': 'Представитель агентства:',
    'manager:': 'Менеджер:'
};
